import React from "react";
import { useMutation } from 'react-query';
import { POSTwithoutToken } from "../../Services"
import { notification } from "antd";



const useLogin = (setState) => {
    const api = "sesion/iniciarSesion"
    return useMutation(async (data) => await POSTwithoutToken(data, api), {
        onMutate: (variables) => {
            setState(true)
        },
        onSuccess: (response) => {
            setState(false)
            const userData = {
                id: response.datos.dataUser.id,
                usua_nombre: response.datos.dataUser.usua_nombre,
                usua_nombre_real: response.datos.dataUser.usua_nombre_real,
                usua_identificador: response.datos.dataUser.usua_identificador,
                usua_ig: response.datos.dataUser.usua_ig,
                usua_coin: response.datos.dataUser.usua_coin,
                usua_comienzo: response.datos.dataUser.usua_comienzo,
                usua_qr_url: response.datos.dataUser.usua_qr_url,
                usua_correo: response.datos.dataUser.usua_correo,
                usua_password: response.datos.dataUser.usua_password,
                tius_id: response.datos.dataUser.tius_id,
                role_id: response.datos.dataUser.role_id,
                imag_id: response.datos.dataUser.imag_id,
                created_at: response.datos.dataUser.created_at,
                updated_at: response.datos.dataUser.updated_at,
                imag_url: response.datos.dataUser.imagen.imag_url,
                imag_nombre: response.datos.dataUser.imagen.imag_nombre,
                tiam_id: response.datos.dataUser.tiam_id
            };
            localStorage.setItem("dataUser", JSON.stringify(userData))
            localStorage.setItem("token", response.datos.token)
            localStorage.setItem("isAdmin", response.datos.isAdmin);

        },
        onError: (error) => {
            setState(false)
            /* if (error.status == 401) {
                notification.open({
                    message: "Ocurrió un error :c",
                    description: 'Credenciales incorrectas',
                });
            } */
        }
    });

}

export default useLogin